import api from '@/api'
const state = {
  isLoading: false,
  expandedMenu: true,
  toast: null,
  isMobile: false,
  awb: {},
  visibleProfileScreen: false,
  activeComponent: null,
  captchaToken: null,
  ongkirList: [],
  logisticProvider: []
}
const actions = {
  setToast: ({ commit }, { options }) => {
    commit('setToastState', options)
  },
  setCaptchaToken: ({ commit }, { data }) => {
    commit('setCaptchaToken', data)
  },
  toggleProfileScreen: ({ commit }, { options }) => {
    commit('setProfileScreenState', options)
  },
  showLoading: ({ commit }) => {
    commit('setLoadingStatus', true)
  },
  hideLoading: ({ commit }) => {
    commit('setLoadingStatus', false)
  },
  expandMenu: ({ commit }, value) => {
    commit('setExpandMenu', value)
  },
  uploadImage({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.common.uploadImage(payloads).then(
        response => {
          resolve(response.data.data)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  checkAwb({ commit }, { awbNumber }) {
    return new Promise((resolve, reject) => {
      api.common.checkAwb(awbNumber).then(
        response => {
          commit('setAwbDetail', response.data.data)
          resolve(response.data.data)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  ongkir({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.common.ongkir(params).then(
        response => {
          commit('setOngkir', response.data.data)
          resolve(response.data.data)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getLogisticProvider({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.common.logisticProvider(params).then(
        response => {
          commit('setLogisticProvider', response.data.data)
          resolve(response.data.data)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setIsMobile(state, value) {
    state.isMobile = value
  },
  setCaptchaToken(state, value) {
    state.captchaToken = value
  },
  setProfileScreenState(state, value) {
    state.visibleProfileScreen = value.value
    state.activeComponent = value.activeComponent || null
  },
  setLoadingStatus(state, value) {
    state.isLoading = value
  },
  setExpandMenu(state, value) {
    state.expandedMenu = value
  },
  setToastState(state, value) {
    state.toast = value
  },
  setAwbDetail(state, value) {
    state.awb = value
  },
  setOngkir(state, value) {
    state.ongkirList = value
  },
  setLogisticProvider(state, value) {
    state.logisticProvider = value
  }
}
const getters = {
  isLoading: state => state.isLoading,
  expandedMenu: state => state.expandedMenu,
  toast: state => state.toast,
  isMobile: state => state.isMobile,
  awb: state => state.awb,
  visibleProfileScreen: state => state.visibleProfileScreen,
  activeComponent: state => state.activeComponent,
  captchaToken: state => state.captchaToken,
  ongkirList: state => state.ongkirList,
  logisticProvider: state => state.logisticProvider
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
